import * as Sentry from "@sentry/react";

// Initialize Sentry
export const initSentry = () => {
  // You'll need to replace this with your actual Sentry DSN
  const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN || "";



  if (SENTRY_DSN && SENTRY_DSN !== "") {
    Sentry.init({
      dsn: SENTRY_DSN,

      // Setting this option to true will send default PII data to Sentry.
      // For example, automatic IP address collection on events
      sendDefaultPii: true,

      // Performance Monitoring
      tracesSampleRate: 1.0, // Capture 100% of the transactions, adjust in production

      // Session Replay
      replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then lower it in production
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

      // Environment
      environment: import.meta.env.MODE,

      // Release version
      release: import.meta.env.VITE_APP_VERSION || "1.0.0",

      // Before send callback to filter out certain errors
      beforeSend(event, hint) {
        // Don't send errors from localhost in development
        if (import.meta.env.DEV && window.location.hostname === "localhost") {
          return null;
        }

        // Filter out certain error types if needed
        if (event.exception) {
          const exception = event.exception.values?.[0];
          if (exception?.type === "ChunkLoadError") {
            return null; // Don't send chunk load errors
          }
        }

        return event;
      },

      // Enable debug mode in development
      debug: import.meta.env.DEV,
    });
  }
};

// Export Sentry for use in other parts of the app
export { Sentry };

// Helper function to capture user information
export const setSentryUser = (user: {
  id: string;
  uid?: string;
  email?: string;
  username?: string;
  role?: string;
}) => {
  Sentry.setUser({
    id: user.id,
    email: user.email,
    username: user.username,
    extra: {
      role: user.role,
      uid: user.uid,
    },
  });
};

// Helper function to clear user information
export const clearSentryUser = () => {
  Sentry.setUser(null);
};

// Helper function to add breadcrumbs
export const addSentryBreadcrumb = (
  message: string,
  category: string = "app",
  data?: Record<string, any>
) => {
  Sentry.addBreadcrumb({
    message,
    category,
    data,
    level: "info",
  });
}; 